import { Button, Page } from '@superops/ui-design-system';
import React, { useState } from 'react';
import { SVGIcon } from '@superops/super-icons';
import { PlanWrapper } from '@nile/components/src/Pages/Pricing/styles';
import { withRouter } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import { getTranslatedText } from '@nile/components';
import PlanNameInfoCard from './PlanNameInfoCard';
import ITPricingEstimateContainer from './ITPricingEstimateContainer';

function ItPlanPurchase(props) {
  const {
    isTrailExpired,
    selectedPlan,
    tenure,
    subscription,
    setTenure,
    handleClose,
    setSelectedPlan
  } = props;
  const intl = useIntl();
  const [pageLoader, setpageLoader] = useState(false);

  return (
    <Page
      variant="secondary"
      divider
      fullWidth
      contentHeight="80px"
      title={getTranslatedText(intl, 'itsm.purchase.modal.header')}
      breadcrumbs={
        setSelectedPlan
          ? [
              {
                id: 'Back',
                content: 'back',
                onAction: () => {
                  setSelectedPlan && setSelectedPlan(null);
                }
              }
            ]
          : []
      }
      primaryAction={
        !isTrailExpired && (
          <Button plain onClick={() => handleClose(false)}>
            <SVGIcon name="Close" />
          </Button>
        )
      }
    >
      <div className="plan-container fh">
        <PlanWrapper className="fh">
          <div className="p20 white-to-grey-bg">
            <div
              className={`${pageLoader ? 'disabled pointer-events-none' : ''}`}
            >
              <PlanNameInfoCard
                plan={selectedPlan}
                tenure={tenure}
                hideDescription
                setTenure={setTenure}
                subscription={subscription}
              />
            </div>
            <div className="mt20">
              <ITPricingEstimateContainer
                {...props}
                setpageLoader={setpageLoader}
              />
            </div>
          </div>
        </PlanWrapper>
      </div>
    </Page>
  );
}

export default withRouter(ItPlanPurchase);
